import React from 'react'
import Icon from './Icon'

class Lusha extends React.Component {
  render () {
    return (
      <Icon>
        <svg width='20px' viewBox='0 0 40 24'>
          <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
            <g fill='#2D4373'>
              <path
                d='M7.28209717,19.8833333 C3.3890699,19.8833333 0.233147743,16.80156 0.233147743,13 C0.233147743,9.19843997 3.3890699,6.11666667 7.28209717,6.11666667 C11.1751244,6.11666667 14.3310466,9.19843997 14.3310466,13 C14.3310466,16.80156 11.1751244,19.8833333 7.28209717,19.8833333 Z M7.28209717,17.7833333 C9.98742121,17.7833333 12.1805197,15.6417621 12.1805197,13 C12.1805197,10.3582379 9.98742121,8.21666667 7.28209717,8.21666667 C4.57677313,8.21666667 2.38367469,10.3582379 2.38367469,13 C2.38367469,15.6417621 4.57677313,17.7833333 7.28209717,17.7833333 Z'
                fillRule='nonzero'
              />
              <path
                d='M27.8315769,19.8833333 C23.9385496,19.8833333 20.7826274,16.80156 20.7826274,13 C20.7826274,9.19843997 23.9385496,6.11666667 27.8315769,6.11666667 C31.7246041,6.11666667 34.8805263,9.19843997 34.8805263,13 C34.8805263,16.80156 31.7246041,19.8833333 27.8315769,19.8833333 Z M27.8315769,17.7833333 C30.5369009,17.7833333 32.7299993,15.6417621 32.7299993,13 C32.7299993,10.3582379 30.5369009,8.21666667 27.8315769,8.21666667 C25.1262528,8.21666667 22.9331544,10.3582379 22.9331544,13 C22.9331544,15.6417621 25.1262528,17.7833333 27.8315769,17.7833333 Z'
                fillRule='nonzero'
              />
              <path
                d='M22.3366235,11.4024459 C20.7476562,10.4604882 19.1641424,9.97942708 17.5962727,9.97942708 C16.0173829,9.97942708 14.4775354,10.4674976 12.9949627,11.4239125 C12.4994713,11.7435564 12.3631533,12.3949167 12.690488,12.8787665 C13.0178227,13.3626163 13.684855,13.4957314 14.1803464,13.1760875 C15.3238542,12.4384051 16.4564188,12.0794271 17.5962727,12.0794271 C18.7471466,12.0794271 19.9518717,12.4454146 21.2206386,13.1975541 C21.7282709,13.4984842 22.3896099,13.3405877 22.6977806,12.8448823 C23.0059513,12.3491769 22.8442558,11.7033761 22.3366235,11.4024459 Z'
                fillRule='nonzero'
              />
            </g>
          </g>
        </svg>
      </Icon>
    )
  }
}

export default Lusha
